/** Value-mirror of the API coin constants; a parity spec fails the build if the two ever drift. */

export const COIN_PEG_SOM_PER_COIN = 1;
export const COIN_REDEMPTION_CAP_PCT = 100;
export const WELCOME_COINS = 10_000;
export const REFERRAL_COINS = 59_000;

/** Client-side pre-validation only — the server re-validates. Not covered by the parity spec. */
export const COIN_TOPUP_MIN = 1_000;
export const COIN_TOPUP_MAX = 100_000_000;

/** Preset purchase amounts (coins) offered in the Buy Coins modal. */
export const COIN_TOPUP_PACKS = [25_000, 50_000, 100_000, 250_000];

/** Shared formatter so the header pill, billing panel and checkout render coins identically. */
export function formatCoins(amount: number): string {
  return `${new Intl.NumberFormat('uz-UZ').format(amount)} so'm`;
}
